// Graph View Calcs.xlsm, Expected vs CP Graph!B9, B13:C15 and F13:G15.
export const VESSEL_CARD_EXPECTED_CURVE_INTERVAL = 0.1;
export const VESSEL_CARD_EXPECTED_CURVE_EXPONENT = 2.8;
export const VESSEL_CARD_EXPECTED_CURVE_AUXILIARY = 2;
export const VESSEL_CARD_EXPECTED_CURVE_SPEED_PRECISION = 10;
// Protect rendering from extreme custom inputs; normal vessel curves need only tens of points.
export const VESSEL_CARD_EXPECTED_CURVE_MAX_POINTS = 2_000;
